import { useAiStore } from "../stores/ai";

export function askAssistantToApply(suggestion: string) {
  const prompt =
    `Please apply this suggestion to my current resume. Quote the current text and give a replacement I can paste. ` +
    `Do not invent employers, jobs, or dates. Example metrics belong in [brackets].\n\n${suggestion}`;
  const store = useAiStore.getState();
  store.setPendingSend(prompt);
  store.setPanelOpen(true);
}
